import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { modalEventListenerAllowScroll } from "../../../utils/ModalEventListener";
import { agingListColumns } from "../../../utils/constant";
import { axios_instance } from "../../../api/axios_instance";
import { Link } from "react-router-dom";
import { useCallback } from "react";
import ContainerLoading from "../../../layouts/ContainerLoading";
import ModalWrapper from "../../../layouts/ModalWrapper";

const RCAgingModal = ({
  dealer_id,
  aging,
  rcAgentName,
  statuses,
  substatuses,
  closeRCAgingModal,
  showRCAgingModal,
}) => {
  const initialState = { agingData: [] };
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState(initialState);

  const ref = useRef();

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const agingResult = await axios_instance({
        url: "/dts/getRCAgeing",
        method: "POST",
        data: { dealer_id, aging, rcAgentName },
      });
      setState((prevState) => ({
        ...prevState,
        agingData: agingResult.data.agingdata,
      }));
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [dealer_id, aging, rcAgentName]);

  useEffect(() => {
    if (showRCAgingModal) fetchData();
  }, [fetchData]);

  return ReactDOM.createPortal(
    <ModalWrapper show={showRCAgingModal} onClose={closeRCAgingModal}>
      <div className="modal-wrapper rc-aging-wrapper">
        <div className="rcaging-modal-content" ref={ref}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal">
              <span aria-hidden="true" onClick={closeRCAgingModal}>
                ×
              </span>
            </button>
            <h4 className="modal-title" id="myModalLabel">
              RC Age
            </h4>
          </div>

          <div className="modal-body">
            {!isLoading ? (
              <div className="table-responsive">
                <table className="table table-striped jambo_table bulk_action">
                  <thead>
                    <tr className="headings">
                      {agingListColumns.map((col, idx) => {
                        return (
                          <th
                            width={col.width}
                            className="column-title"
                            key={idx}
                          >
                            {col.title}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>

                  <tbody id="rc-aging-data">
                    {state.agingData.length ? (
                      state.agingData.map((data, idx) => {
                        const rc_transfer_by = data.rc_transfer_by
                          ? data.rc_transfer_by
                          : "N/A";
                        let stage =
                            !data.stage || statuses.length === 0
                              ? "Payment Requested"
                              : statuses[data.stage - 1].label,
                          substage = "Open";

                        if (data.sub_stage && substatuses.length > 0) {
                          if (
                            [3, 4, 12, 14].includes(parseInt(data.sub_stage))
                          ) {
                            substage = "Discrepancy Identified";
                          } else {
                            substage = substatuses.find(
                              (substatus) =>
                                substatus.value === parseInt(data.sub_stage)
                            )?.label;
                          }
                        }
                        return (
                          <tr className="even pointer" key={idx}>
                            <td>
                              <Link
                                to={`/payments/details?lead_id=${btoa(
                                  data.finance_lead_id
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="detailsmodal-link"
                              >
                                {data.finance_lead_id}
                              </Link>
                            </td>
                            <td>{rc_transfer_by}</td>
                            <td>{data.original_docs_collected}</td>
                            <td>{data.rc_age_date}</td>
                            <td>{`${stage}-${substage}`}</td>
                            <td>{data.rcSubStatus}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="7">No record found.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <ContainerLoading />
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              data-dismiss="modal"
              onClick={closeRCAgingModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default RCAgingModal;
